export const URL = {
  LOBBY: '/lobby',
  GAME: '/',
};
